import React from "react";
import { useState, useEffect, useRef } from "react";
import "../CaseStudies1/CaseStudies1.scss";
import meta_tags from "../../Data/MetaTags";
import { useLocation } from "react-router-dom";
function CaseStudiesenhancing() {
  const [rendercount, setRenderCount] = useState(() => false);

  const location = useLocation();

  useEffect(() => {
    setRenderCount(true);
    if (rendercount === true) {
     
      document.title = meta_tags[location.pathname.replace("/", "")]
        ? meta_tags[location.pathname.replace("/", "")].title
        : "";
      
      document.getElementById("meta-tags").content = meta_tags[
        location.pathname.replace("/", "")
      ]
        ? meta_tags[location.pathname.replace("/", "")].content
        : "";
      document.getElementById("canonical-link").href = meta_tags[
        location.pathname.replace("/", "")
      ]
        ? meta_tags[location.pathname.replace("/", "")].link
        : "";
      
      if (!(document.getElementById("link1") == null)) {
        document.getElementById("link1").remove();
        document.getElementById("link2").remove();
        document.getElementById("link3").remove();
        document.getElementById("link4").remove();
        document.getElementById("link5").remove();
        document.getElementById("link6").remove();
      }
    }
  }, [rendercount]);

  return (
    <>
      <section className="details-sec">
        <div className="container">
          <div className="heading-sec">
            <h3>
            Enhancing customer experience in insurance with welcome calls via Greetly
            </h3>
          </div>
          <div className="details-contents">
            <h3>Company Background:</h3>
            <p className="sm-para">
            ABC Insurance Co. is a leading insurance provider having a wide range of insurance products; life, health, and property insurance.
            </p>
          </div>
          <div className="details-contents">
            <h3>Challenge:</h3>
            <p className="sm-para">The insurance industry is highly competitive, with customers often switching insurance providers based on pricing and perceived value. ABC Insurance Co. struggles to retain customers beyond their initial policy purchase, leading to a high churn rate and missed opportunities for long-term relationships.</p>
      
          </div>

          <div className="details-contents">
            <h3>Solution:</h3>
            <p className="sm-para">To address these challenges, ABC Insurance Co. implements a welcome call via Greetly –</p>
            <ul>
              <li className="sm-para">
              <strong>Personalized Onboarding:</strong> Within 24-48 hours of purchase, customers receive a warm welcome call message offering assistance and answering queries.
              </li>
              <li className="sm-para">
              <strong>Policy Explanation and Customization:</strong> This call provides a detailed explanation of the customer's insurance policy, including coverage limits, deductibles, and additional riders enhancing understanding and satisfaction.
              </li>
              <li className="sm-para"><strong>Claims Assistance and Support:</strong> Customers are informed about the claim process, and provided with guidance on how to file a claim in case of an emergency or loss.</li>
              <li className="sm-para"><strong>Introduction to Additional Services:</strong> Customers are introduced to ABC Insurance Co.'s range of additional services, or discounts to improve overall customer perception.</li>
            </ul>
          
         
          </div>
          <div className="details-contents">
            <h3>Results:</h3>
            <ul>
              <li className="sm-para">
              <strong>30% Increase in Satisfaction:</strong> Welcome calls boost satisfaction scores within the first month.
              </li>
              <li className="sm-para">
              <strong>25% Rise in Policy Retention:</strong> Proactive engagement leads to higher policy retention rates.
              </li>
              <li className="sm-para">
              <strong>20% Decrease in Churn:</strong> ABC Insurance Co. sees a notable drop in churn within three months.</li>
              <li className="sm-para">
              <strong>40% Higher Renewal Rates:</strong> Customers engaged with welcome calls are more likely to renew policies and refer others.
              </li>
              <li className="sm-para">
              <strong>15% Boost in Lifetime Value:</strong> Engaged customers show increased value over time.
              </li>
            </ul>
          </div>

          <div className="details-contents">
            <h3>Conclusion:</h3>
            <p className="sm-para">
            By implementing welcome calls, ABC Insurance Co. enhances customer engagement, satisfaction, and loyalty, solidifying its position in the competitive insurance landscape.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default CaseStudiesenhancing;
